
/* ========================================================================
   NUPEP COLD CHAIN LOGISTICS UPGRADE
   Version 1.0.0 - cart drawer, cart page and pre-checkout add-on
   ======================================================================== */
(function () {
  'use strict';

  const ADD_SELECTOR = '[data-cold-chain-add]';
  const REMOVE_SELECTOR = '[data-cold-chain-remove]';

  function setBusy(button, busy) {
    if (!button) return;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (busy) button.dataset.originalText = button.querySelector('.nupep-cold-chain-addon__button-text')?.textContent || '';
  }

  async function addColdChain(button) {
    const addon = button.closest('[data-cold-chain-addon]');
    if (!addon || button.getAttribute('aria-busy') === 'true') return;

    const variantId = Number(addon.dataset.coldChainVariantId);
    if (!variantId) return;

    setBusy(button, true);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer',
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add the Cold Chain Upgrade.');

      if (window.location.pathname === '/cart' || document.body.classList.contains('template-cart')) {
        await refreshCartPage(data);
      }

      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections && data.sections['cart-drawer']) {
        drawer.renderContents(data);
      }

      // The pre-checkout page is a full custom page; reload keeps its summary and totals authoritative.
      if (document.querySelector('.precheckout')) {
        window.location.reload();
        return;
      }
    } catch (error) {
      console.error('[NUPEP] Cold Chain add failed:', error);
      button.removeAttribute('aria-busy');
      button.setAttribute('aria-busy', 'false');
      button.insertAdjacentHTML('afterend', '<p class="nupep-cold-chain-error" role="alert">Unable to add the upgrade. Please try again.</p>');
    }
  }

  async function removeColdChain(button) {
    const addon = button.closest('[data-cold-chain-addon]');
    if (!addon || button.dataset.busy === 'true') return;

    const lineKey = button.dataset.lineKey || addon.dataset.coldChainLineKey;
    if (!lineKey) return;

    button.dataset.busy = 'true';
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
          sections: 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer',
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to remove the Cold Chain Upgrade.');

      if (window.location.pathname === '/cart' || document.body.classList.contains('template-cart')) {
        await refreshCartPage(data);
      }

      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections && data.sections['cart-drawer']) {
        drawer.renderContents({
          id: null,
          sections: {
            'cart-drawer': data.sections['cart-drawer'],
            'cart-icon-bubble': data.sections['cart-icon-bubble'] || ''
          }
        });
      }

      if (document.querySelector('.precheckout')) {
        window.location.reload();
      }
    } catch (error) {
      console.error('[NUPEP] Cold Chain remove failed:', error);
      button.dataset.busy = 'false';
      button.removeAttribute('aria-busy');
    }
  }

  async function refreshCartPage(data) {
    if (!data || !data.sections) return;

    const replacements = [
      ['main-cart-items', '#main-cart-items'],
      ['main-cart-footer', '#main-cart-footer'],
      ['cart-icon-bubble', '#cart-icon-bubble']
    ];

    replacements.forEach(([sectionId, selector]) => {
      const html = data.sections[sectionId];
      if (!html) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector(selector) || parsed.querySelector('.shopify-section');
      const target = document.querySelector(selector);
      if (source && target) target.replaceWith(source);
    });
  }

  document.addEventListener('nupep:cold-chain-after-product-add', async function (event) {
    const variantId = Number(event.detail?.variantId);
    if (!variantId || window.__nupepColdChainAdding) return;
    window.__nupepColdChainAdding = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add Cold Chain Logistics Upgrade.');
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections && data.sections['cart-drawer']) drawer.renderContents({ id: variantId, sections: data.sections });
    } catch (error) { console.error('[NUPEP] Cold Chain product-page add failed:', error); }
    finally { window.__nupepColdChainAdding = false; }
  });

  document.addEventListener('click', function (event) {
    const addButton = event.target.closest(ADD_SELECTOR);
    if (addButton) {
      event.preventDefault();
      addColdChain(addButton);
      return;
    }

    const removeButton = event.target.closest(REMOVE_SELECTOR);
    if (removeButton) {
      event.preventDefault();
      removeColdChain(removeButton);
    }
  });
})();
